import { useDispatch, useSelector } from "react-redux";
import commonStyles from "../../FormSection.styles";
import SelectDropdown from "../../../../components/dropdown/selectdropdown/SelectDropdown";
import Label from "../../../../components/label/Label";
import RichGrid from "../../../../components/richgrid/RichGrid";
import { LABEL_WEIGHT } from "../../../../components/label/constants";
import { componentKey, setSelectedState, setFormList, setSelectedForm, setSelectedTaxYear, setSelectedPayer, setPayerList, setStatePayrollResubmitGridData, setSelectedStatePayrollResubmitGridData, setPaginationState, setUrlFormIdParam, setUrlPayerIdParam } from "./StatePayrollResubmitSlice";
import { getStateResubmitStates, getStateResubmitForms, getStateResubmitPayers, getStatePayrollResubmitGridData, reSubmitSelectedFormsToStatePayroll, statePayrollResubmitViewPDF } from "./StatePayrollResubmitSaga";
import { useEffect } from "react";
import Button from "../../../../components/button/Button";
import styles from "../stateresubmit/StateResubmit.styles"
import { BUTTON_TYPE } from "../../../../components/button/constants";
import Loadable from "../../../../components/loadable/Loadable";
import { TOASTER_VARIANT } from "../../../../components/toast/constants";
import { addNotifications } from "../../../toaster/ToasterPortalSlice";
import { VEC_ICON_NAME } from "../../../../components/icons/constants";
import Icons from "../../../../components/icons/Icons";
import { ROW_SELECTION_OPTIONS } from "../../../../components/richgrid/constants";
import { IRS_STATE_RESUBMIT_LOADING_STATES, IRS_STATE_RESUBMIT_MESSAGE_MAP } from "../constant";
import useGarbageCollector from "../../../../../libs/garbagecollector/garbageCollectorHooks";
import useTxSearchParams from "../../../../../libs/txsearchparams/TxSearchParamsHook";
import { QUERY_PARAMS } from "../../constants";

export default function StatePayrollResubmitForms() {

    useGarbageCollector(componentKey);

    const dispatch = useDispatch();
    const [queryParams, setQueryParams] = useTxSearchParams();

    const { loadingState, stateList, selectedState, formList, selectedForm, taxYearList, selectedTaxYear, payerList, selectedPayer, statePayrollResubmitGridData, selectedStatePayrollResubmitGridData, paginationState, reloadResubmitGridData, urlFormIdParam, urlPayerIdParam } = useSelector(state => state[componentKey]);

    useEffect(() => {
        const stateParamFromUrl = queryParams.get(QUERY_PARAMS.STATENAME)
        const formIdParamFromUrl = queryParams.get(QUERY_PARAMS.FORM_ID)
        const taxYearParamFromUrl = queryParams.get(QUERY_PARAMS.TAX_YEAR)
        const payerIdParamFromUrl = queryParams.get(QUERY_PARAMS.PAYER_ID)

        dispatch(setUrlFormIdParam(formIdParamFromUrl))
        dispatch(setUrlPayerIdParam(payerIdParamFromUrl))
        dispatch(getStateResubmitStates({ urlStateParam: stateParamFromUrl, urlTaxYearParam: taxYearParamFromUrl }));
    }, [])

    useEffect(() => {
        if (selectedState?.value) {
            dispatch(getStateResubmitForms({ stateNames: selectedState?.value, urlFormIdParam: urlFormIdParam }));
        } else {
            dispatch(setFormList([]));
        }
        dispatch(setSelectedForm({ label: "", value: "" }))

    }, [selectedState])

    useEffect(() => {
        if (selectedForm?.FormId) {
            dispatch(setPayerList([]));
            dispatch(getStateResubmitPayers({ formId: selectedForm?.value, urlPayerIdParam: urlPayerIdParam }));
        } else {
            dispatch(setStatePayrollResubmitGridData([]));
            dispatch(setSelectedStatePayrollResubmitGridData([]));
            dispatch(setPayerList([]));
        }
        dispatch(setSelectedPayer({ label: "", value: "" }))

    }, [selectedForm])

    useEffect(() => {
        if (reloadResubmitGridData) {
            if (selectedForm?.value && selectedTaxYear?.value && selectedPayer?.value) {
                getGridRecords();
            }
        }
    }, [reloadResubmitGridData])

    const getGridRecords = () => {
        dispatch(getStatePayrollResubmitGridData({
            payer: selectedPayer?.PayerDetailId,
            taxYear: selectedTaxYear?.value,
            formId: selectedForm?.value
        }))
    }

    const STATE_PAYROLL_RESUBMIT_FORMS_COLUMN = [
        {
            field: "ReferenceNo",
            header: <Label weight={LABEL_WEIGHT[700]}>Reference Number</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row?.StatePayrollReferenceNumber || "-"}</span>
        },
        {
            field: "FormName",
            header: <Label weight={LABEL_WEIGHT[700]}>Form Name</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row?.FormName || "-"}</span>
        },
        {
            field: "TIN",
            header: <Label weight={LABEL_WEIGHT[700]}>Payer TIN</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row?.PayerIdNumber || "-"}</span>
        },
        {
            field: "Action",
            header: (
                <Label Label weight={LABEL_WEIGHT[700]}>
                    Action
                </Label>
            ),
            renderLogic: (row, idx) => (
                <Loadable
                    currentState={loadingState.state}
                    loadingStates={[`${IRS_STATE_RESUBMIT_LOADING_STATES.FETCHING_VIEW_PDF_LIST_LOADING}-${row?.FormId}`]}
                    messageMap={IRS_STATE_RESUBMIT_MESSAGE_MAP}
                    isNewLoadable={true}
                    isFullWidth={false}
                >
                    <div style={commonStyles.actionButtons}>
                        <Button title={'View PDF'} style={commonStyles.buttonBackgroundWIcon} onClickCb={() => dispatch(statePayrollResubmitViewPDF({
                            formId: row?.FormId,
                            payerId: selectedPayer?.PayerDetailId,
                            formTypeId: selectedForm?.FormId,
                            payerName: selectedPayer?.PayerName,
                        }))}><Icons familyName={'vec'} iconName={VEC_ICON_NAME.VIEW_ICON} /></Button>
                    </div>
                </Loadable>
            ),
        },
    ];

    return (
        <div>
            <div style={commonStyles.dropdownContainer}>
                <div style={commonStyles.selectDropdown}>
                    <Loadable
                        currentState={loadingState.state}
                        loadingStates={[IRS_STATE_RESUBMIT_LOADING_STATES.FETCHING_STATES_LIST_LOADING]}
                        messageMap={IRS_STATE_RESUBMIT_MESSAGE_MAP}
                        isNewLoadable={true}
                        isFullWidth={false}
                    ><SelectDropdown
                            name="selectedState"
                            label="State"
                            placeHolder="Select State"
                            options={stateList}
                            onSelectCb={(name, selectedOption) => {
                                dispatch(setSelectedState(selectedOption));

                                if (selectedOption?.value) {
                                    queryParams.set(QUERY_PARAMS.STATENAME, selectedOption?.value)
                                } else {
                                    queryParams.delete(QUERY_PARAMS.STATENAME)
                                }
                                setQueryParams(queryParams);
                            }}
                            value={selectedState}

                        />
                    </Loadable>
                    <Loadable
                        currentState={loadingState.state}
                        loadingStates={[IRS_STATE_RESUBMIT_LOADING_STATES.FETCHING_FORMS_LIST_LOADING]}
                        messageMap={IRS_STATE_RESUBMIT_MESSAGE_MAP}
                        isNewLoadable={true}
                        isFullWidth={false}
                    ><SelectDropdown
                            name="selectedForm"
                            label="Form"
                            placeHolder="Select Form"
                            options={formList}
                            onSelectCb={(name, selectedOption) => {
                                dispatch(setSelectedForm(selectedOption));

                                if (selectedOption?.value) {
                                    queryParams.set(QUERY_PARAMS.FORM_ID, selectedOption?.value)
                                } else {
                                    queryParams.delete(QUERY_PARAMS.FORM_ID)
                                }
                                setQueryParams(queryParams);
                            }}
                            value={selectedForm}
                        />
                    </Loadable>
                    <SelectDropdown
                        name="selectedTaxYear"
                        label="Tax Year"
                        placeHolder="Select Tax Year"
                        options={taxYearList}
                        onSelectCb={(name, selectedOption) => {
                            dispatch(setSelectedTaxYear(selectedOption));

                            if (selectedOption?.value) {
                                queryParams.set(QUERY_PARAMS.TAX_YEAR, selectedOption?.value)
                            } else {
                                queryParams.delete(QUERY_PARAMS.TAX_YEAR)
                            }
                            setQueryParams(queryParams);
                        }}
                        value={selectedTaxYear}

                    />
                    <Loadable
                        currentState={loadingState.state}
                        loadingStates={[IRS_STATE_RESUBMIT_LOADING_STATES.FETCHING_PAYERS_LIST_LOADING]}
                        messageMap={IRS_STATE_RESUBMIT_MESSAGE_MAP}
                        isNewLoadable={true}
                        isFullWidth={false}
                    ><SelectDropdown
                            name="selectedPayer"
                            label="Payer"
                            placeHolder="Select Payer"
                            options={payerList}
                            onSelectCb={(name, selectedOption) => {
                                dispatch(setSelectedPayer(selectedOption));

                                if (selectedOption?.value) {
                                    queryParams.set(QUERY_PARAMS.PAYER_ID, selectedOption?.value)
                                } else {
                                    queryParams.delete(QUERY_PARAMS.PAYER_ID)
                                }
                                setQueryParams(queryParams);
                            }}
                            value={selectedPayer}
                        />
                    </Loadable>

                    <Button
                        onClickCb={() => {
                            if (selectedForm?.value && selectedTaxYear?.value && selectedPayer?.value) {
                                getGridRecords(1, paginationState?.PageSize)
                                dispatch(setPaginationState({ ...paginationState, PageNumber: 1 }));
                            } else {
                                dispatch(addNotifications({ heading: "Fields missing", variant: TOASTER_VARIANT.WARNING, message: "Please select state, form, tax year and payer" }))
                            }
                        }}>
                        Search
                    </Button>
                </div>
            </div>
            <Loadable
                currentState={loadingState.state}
                loadingStates={[IRS_STATE_RESUBMIT_LOADING_STATES.FETCHING_GRID_RECORDS_LOADING]}
                messageMap={IRS_STATE_RESUBMIT_MESSAGE_MAP}
                isNewLoadable={true}
                isFullWidth={false}
            ><RichGrid
                    selectable={true}
                    data={statePayrollResubmitGridData}
                    columns={STATE_PAYROLL_RESUBMIT_FORMS_COLUMN}
                    extractRowKey={(row) => row.FormId}
                    selectedRows={selectedStatePayrollResubmitGridData}
                    onHeaderSelectionChangeCallBack={(selectedData) => dispatch(setSelectedStatePayrollResubmitGridData(selectedData))}
                    onSelectionChangeCallBack={(selectedData) => dispatch(setSelectedStatePayrollResubmitGridData(selectedData))}
                    paginationProps={{
                        skip: paginationState?.Skip,
                        take: paginationState?.PageSize,
                        takeOptions: ROW_SELECTION_OPTIONS,
                        total: paginationState?.total,
                        onChangeTakeCb: (newTake) => {
                            dispatch(setPaginationState({ ...paginationState, PageSize: newTake, PageNumber: 1, Skip: 0 }));
                            getGridRecords(1, newTake)
                        },
                        onChange: (take, skip) => {
                            dispatch(setPaginationState({ ...paginationState, PageSize: take, Skip: skip, PageNumber: Math.ceil((take + skip) / take) }))
                            getGridRecords(Math.ceil((take + skip) / take), take)
                        }
                    }}
                />

                <div style={styles.submitBtnContainer}>
                    <Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} style={{ ...commonStyles.button }} onClickCb={() => {
                        if (selectedStatePayrollResubmitGridData.length) {
                            let jsonData = selectedStatePayrollResubmitGridData.map(item => {
                                let obj = {
                                    value: item?.StatePayrollReferenceNumber ?? null
                                };
                                obj.key = (item?.StatePayrollReferenceNumber ? true : false).toString();
                                return obj;
                            });
                            dispatch(reSubmitSelectedFormsToStatePayroll({
                                data: {
                                    jsonPreferences: jsonData,
                                    FormTypeId: selectedForm?.FormId,
                                }
                            }))
                        } else {
                            dispatch(addNotifications({ heading: "Error", message: "Please select form details to submit to IRS", variant: TOASTER_VARIANT.WARNING }))
                        }
                    }}>Submit</Button>
                </div>
            </Loadable>
        </div>
    )
}

